// @ts-ignore-line
import { Map, MapMouseEvent, Point, Marker } from "mapbox-gl";
// import mapbox from "mapbox-gl";
import { updatePinCount } from "../../state/map";
import { store } from "../../state";

export type PinInfo = {
  lat: number;
  lng: number;
};

export const PIN_WIDTH_PX = 16;
const PIN_HEIGHT_PX = 16;

const MARKER_CLASS_NAME = "mappin-marker";

export const onMapClick = (
  map: Map,
  removalListener: () => void,
) => (e: MapMouseEvent) => {
  if (!window.pinsEnabled) {
    return;
  }
  const pinInfo: PinInfo = {
    lat: e.lngLat.lat,
    lng: e.lngLat.lng,
  };

  const el = document.createElement("div")
  el.style.backgroundImage = "url('/pin-icon.png')";
  el.style.width = `${PIN_WIDTH_PX}px`;
  el.style.height = `${PIN_HEIGHT_PX}px`;
  el.style.backgroundSize = '100%';
  // TODO: Make it so that pins don't get created if border exists.
  el.style.zIndex = "3";
  el.style.cursor = "pointer";
  el.className = MARKER_CLASS_NAME;
  el.id = JSON.stringify(pinInfo);

  // Add click event listener to delete the pin when clicked
  el.addEventListener('click', (event) => {
    event.stopPropagation();
    removePin(map, pinInfo);
  });

  new Marker(el)
    .setLngLat(e.lngLat)
    .setOffset(new Point(PIN_WIDTH_PX/2, -PIN_HEIGHT_PX/2))
    .addTo(map);
  
  // Update pin count in Redux state to trigger re-renders
  const newPinCount = getPins(map).length;
  store.dispatch(updatePinCount(newPinCount));
};

export const removeAllPins = (map: Map | null): void => {
  if (!map) {
    return;
  }
  const container = map.getCanvasContainer();
  Array
    .from(container.getElementsByTagName("div"))
    .filter((el: any) => el.className.includes(MARKER_CLASS_NAME))
    .forEach((el: any) => el.remove());
  
  // Update pin count in Redux state after removing all pins
  store.dispatch(updatePinCount(0));
}

export const removePin = (map: Map | null, pinInfo: PinInfo): void => {
  if (!map) {
    return;
  }
  const container = map.getCanvasContainer();
  const pinId = JSON.stringify(pinInfo);
  const pinElement = Array
    .from(container.getElementsByTagName("div"))
    .find((el: any) => el.className.includes(MARKER_CLASS_NAME) && el.id === pinId);
  
  if (pinElement) {
    pinElement.remove();
    // Update pin count in Redux state after removing pin
    const newPinCount = getPins(map).length;
    store.dispatch(updatePinCount(newPinCount));
  }
}

export const getPins = (map: Map): PinInfo[] => {
  const container = map.getCanvasContainer();
  const markers = Array
    .from(container.getElementsByTagName("div"))
    .filter((el: any) => el.className.includes(MARKER_CLASS_NAME));
  const pinInfo: PinInfo[] = markers.map((marker: any) => JSON.parse(marker.id));
  return pinInfo
}
